import { Dayjs } from 'dayjs';
import { ordersApi } from './config/delfarApi';
import {
    CreateOfferRequestDto,
    GetPrescriptionDataResponseDto,
    ValidateOfferRequestDto,
} from './dto/orders.dto';

export const requestHpAuth = async (orderId: string): Promise<boolean> =>
    ordersApi.post(`${orderId}/request_hp_auth`, undefined).then((r) => r.data);

export const createOffer = async (
    orderId: string,
    bodyData: CreateOfferRequestDto,
): Promise<void> => ordersApi.post<void>(`${orderId}/offers`, bodyData).then((r) => r.data);

export const validateOffer = async (
    orderId: string,
    bodyData: ValidateOfferRequestDto,
): Promise<boolean> => ordersApi.patch<boolean>(`${orderId}/offer`, bodyData).then((r) => r.data);

export const getPrescriptionData = async (
    orderId: string,
): Promise<GetPrescriptionDataResponseDto> =>
    ordersApi
        .get<GetPrescriptionDataResponseDto>(`${orderId}/prescription_data`)
        .then((r) => r.data);

export const toPreviousState = async (orderId: string): Promise<void> =>
    ordersApi.post<void>(`${orderId}/to_previous_state`).then((r) => r.data);

export const rescheduleStock = async (orderId: string, date: Dayjs): Promise<void> =>
    ordersApi
        .post<void>(`${orderId}/reschedule_stock`, { datetime: date.toJSON() })
        .then((r) => r.data);

export const addRejection = async (orderId: string, reason: string): Promise<void> =>
    ordersApi.post<void>(`${orderId}/rejections`, { reason }).then((r) => r.data);
